import { h } from 'preact';

export const Close = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    aria-label={window.TMW.Strings.icons.close}
    aria-hidden="true"
  >
    <title>{window.TMW.Strings.icons.close}</title>
    <path
      d="M1.45545 1.85224L14.8154 15.2122M1 15.5L15 1.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const Angle = () => (
  <svg
    width="12"
    height="7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 7"
  >
    <title>{window.TMW.Strings.icons.close}</title>
    <path
      d="m11 5.625-5-5-5 5"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
